import { useEffect, useState } from "react";
import logoWhite from "@images/logos/logoWhite.png";
import GeneralStrings from "@strings/GeneralStrings.json";
import {
  getMostRecentVideo,
  getYoutubeSubscriberAndViewCount,
} from "@utilities/YoutubeHelper";
import CountUp from "@components/CountUp/CountUp";
import "./YoutubeChannel.scss";

const parseCount = (val: number | string): number =>
  typeof val === "string" ? parseInt(val.replace(/,/g, ""), 10) || 0 : val;

const YOUTUBE_CHANNEL_URL =
  "https://www.youtube.com/channel/UCqiRdTiMJ1jWPeVELNkkQ9Q";
const youtubeStrings = GeneralStrings.youtube;

const YoutubeChannel = () => {
  const [subscribers, setSubscribers] = useState<number | string>(0);
  const [views, setViews] = useState<number | string>(0);
  const [videoSrc, setVideoSrc] = useState<string | undefined>(undefined);

  useEffect(() => {
    getYoutubeSubscriberAndViewCount(setSubscribers, setViews);
    getMostRecentVideo(setVideoSrc);
  }, []);

  return (
    <section className="section youtube-channel">
      <div className="container-fluid">
        <div className="youtube-title-area">
          <h2>{youtubeStrings.title}</h2>
          <div className="separator">
            <img src={logoWhite} className="seperator-img" alt="logo" />
          </div>
        </div>

        <div className="container-fluid youtube-content">
          <div className="youtube-columns">
            <div className="youtube-stats-section">
              <div className="youtube-stat-row">
                <div className="odometer" id="viewsOdometer">
                  <CountUp
                    to={parseCount(views)}
                    separator=","
                    duration={0.5}
                  />
                </div>
                <div className="odometer-text">
                  {youtubeStrings.channelViews}
                </div>
              </div>

              <div className="youtube-stat-divider" />

              <div className="youtube-stat-row">
                <div className="odometer" id="subsOdometer">
                  <CountUp
                    to={parseCount(subscribers)}
                    separator=","
                    duration={0.5}
                  />
                </div>
                <div className="odometer-text">
                  {youtubeStrings.subscribers}
                </div>
              </div>

              <div className="youtube-stat-divider" />

              <a
                href={YOUTUBE_CHANNEL_URL}
                target="_blank"
                className="btn btn-block btn-youtube"
                rel="noreferrer"
              >
                <i className="fab fa-youtube left" /> {youtubeStrings.cta}
              </a>
            </div>

            <div className="youtube-video-section">
              {videoSrc && (
                <iframe
                  className="responsive-iframe"
                  title="Beat Video"
                  src={videoSrc}
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default YoutubeChannel;
